import moment from 'moment'
import { reactive, toRefs } from 'vue'

export const useDesignerDate = () => {
  const defaultDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
  const dateState = reactive({
    uploadTimeDateType: 1,
    dateRange: [defaultDate, defaultDate],
    weekRange: [moment().weekday(0).format('YYYY-MM-DD'), moment().weekday(6).format('YYYY-MM-DD')],
    monthRange: [moment().format('YYYY-MM-01'), moment().endOf('month').format('YYYY-MM-DD')]
  })

  const disabledDate = (date) => {
    return date && date.valueOf() > Date.now() - 1000 * 60 * 60 * 24
  }

  const weekOptions = {
    firstDayOfWeek: 1,
    cellClassName: (date) => {
      if (date && date.valueOf() > Date.now() - 1000 * 60 * 60 * 24) return 'empty-date'
      return ''
    },
    disabledDate: (date) => {
      const isMonday = new Date().getDay() === 1
      if (isMonday) {
        return date && date.valueOf() > Date.now() - 1000 * 60 * 60 * 24
      }
      return date && date.valueOf() > Date.now() + (7 - new Date().getDay()) * 1000 * 60 * 60 * 24
    }
  }

  const monthOptions = {
    disabledDate
  }

  const getDateRange = () => {
    const { uploadTimeDateType, dateRange, weekRange, monthRange } = dateState
    let beginTime
    let endTime
    if (uploadTimeDateType === 1) {
      beginTime = dateRange[0]
      endTime = dateRange[1]
    } else if (uploadTimeDateType === 2) {
      if (weekRange) {
        const [begin, end] = weekRange.map((v) => moment(v).format('YYYY-MM-DD'))
        beginTime = begin
        endTime = end
      }
    } else if (uploadTimeDateType === 3) {
      if (monthRange) {
        beginTime = moment(monthRange[0]).format('YYYY-MM-01')
        endTime = moment(monthRange[1]).endOf('month').format('YYYY-MM-DD')
      }
    }
    return [beginTime, endTime]
  }

  return {
    ...toRefs(dateState),
    weekOptions,
    monthOptions,
    disabledDate,
    getDateRange
  }
}
